// @flow

import { authActionTypes as Types } from '../constants';
import {
  AUTH_ENDPOINT_PATH,
  LOGIN_UI_PATH,
  RAILS_ENDPOINT_PATH
} from '../config';

const getUser = () => async (/* dispatch: Function */) => {
  const authorizationUrl = `${AUTH_ENDPOINT_PATH}v1/auth/authorize`;
  const authResp = await fetch(authorizationUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'include'
  });
  if (authResp.status === 200) {
    const data = await authResp.json();
    const { identity: { id } } = data;
    const meUrl = `${RAILS_ENDPOINT_PATH}api/v1/users/${id}`;

    const meResp = await fetch(meUrl, {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'content-type': 'application/json'
      },
      credentials: 'include'
    });
    if (meResp.status === 200) {
      const meData = await meResp.json();
      const { attributes } = meData.data;
      if (window.Appcues) {
        window.Appcues.identify(id, {
          first_name: attributes.first_name,
          last_name: attributes.last_name,
          company: attributes.company
        });
      }
    }
  }
};

export const refreshCredentials = (
  orgId: number,
  authorizedCallback: Function = () => {}
) => async (dispatch: Function) => {
  // this is for later, on different domains, it requires: https://github.com/localytics/login-ui/pull/28
  const redirect = window.location.href;
  // const redirect = `${window.location.pathname}${window.location.search}`;
  try {
    const response = await fetch(`${AUTH_ENDPOINT_PATH}v1/auth/refresh`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'include'
    });

    if (response.status !== 200) {
      setTimeout(() => {
        window.location = `${LOGIN_UI_PATH}/?next=${encodeURIComponent(
          redirect
        )}`;
      }, 10 * 1000);
    } else {
      dispatch({ type: Types.REFRESH_SUCCESS });
      authorizedCallback();
      dispatch(getUser());
    }
  } catch (e) {
    dispatch({
      type: Types.REFRESH_FAILURE,
      payload: {
        error: 'Unable to refresh credentials'
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/auth.js